import React from 'react';
import PropTypes from 'prop-types';

function Title({ titleValue, titleLevel, classNamePrefix, id }) {
  if (!titleValue) {
    return null;
  }
  const Type = `h${titleLevel}`;
  return (
    <Type
      className={`component-title account-locked-title ${classNamePrefix}`}
      id={id}
    >
      {titleValue}
    </Type>
  );
}

function ComponentHeader({
  hasSeparator = false,
  wrapperClass = '',
  subTitle,
  spanElement,
  title,
  titleLevel,
  titleClass,
  id,
  hasSubtitleSeparator,
  subtitleClass,
  bodyClass,
  children,
}) {
  return (
    <div
      className={`component-header${wrapperClass ? ' ' + wrapperClass : ''}${
        subTitle ? '' : ' no-subtitle'
      }`}
    >
      {hasSeparator && <hr />}
      <div className="row">
        <div className={spanElement ? 'col-xs-8' : 'col-xs-12'}>
          {typeof title === 'object' ? (
            title
          ) : (
            <Title
              titleValue={title}
              titleLevel={titleLevel}
              classNamePrefix={titleClass ? titleClass : ''}
              id={id}
            />
          )}
        </div>
        {spanElement && <div className="col-xs-4">{spanElement}</div>}
      </div>
      {hasSubtitleSeparator === true ? <hr /> : null}
      <div className={bodyClass}>
        <div className="row">
          <div className="col-xs-12">
            {subTitle && (
              <div
                className={`component-header-subtitle${
                  subtitleClass ? ' ' + subtitleClass : ''
                }`}
                dangerouslySetInnerHTML={{ __html: subTitle }}
              />
            )}
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}

ComponentHeader.propTypes = {
  title: PropTypes.node,
  subTitle: PropTypes.string,
  hasSeparator: PropTypes.bool,
  hasSubtitleSeparator: PropTypes.bool,
  titleLevel: PropTypes.number,
  bodyClass: PropTypes.string,
  subtitleClass: PropTypes.string,
  titleClass: PropTypes.string,
  id: PropTypes.string,
  spanElement: PropTypes.element,
  wrapperClass: PropTypes.string,
  children: PropTypes.node,
};

export { ComponentHeader };
